"use strict";
require('slick-carousel');

const Sliders = () => {
    const init = () => {
        $(function() {
            var $bannerSliderContainers = $('.js-banner-slider-container');
            if ($bannerSliderContainers.length > 0) {
                window.togglePlayVideo = function($this){
                    if($this.hasClass('playing')){
                        playPauseMuteVideo($this.parents('.slick-current'),"pause");
                    }else{
                        playPauseMuteVideo($this.parents('.slick-current'),"play");
                    }
                    $this.toggleClass('playing');
                }

                window.toggleMuteVideo = function($this){
                    if($this.hasClass('muted')){
                        playPauseMuteVideo($this.parents('.slick-current'),"unmute");
                    }else{
                        playPauseMuteVideo($this.parents('.slick-current'),"mute");
                    }
                    $this.toggleClass('muted');
                }

                $bannerSliderContainers.each(function(){
                    var $bannerSliderContainer = $(this);
                    var $bannerSlider = $bannerSliderContainer.find('.js-banner-slider');
                    var timeout = null;

                    $bannerSlider.on('init', function(event, slick){
                        setTimeout(function(){
                            $bannerSlider.find('.slick-slide[data-slick-index="0"] .js-play-toggle').trigger('click')
                            if($bannerSlider.find('.slick-slide[data-slick-index="0"] video').length <= 0 
                                && $bannerSlider.find('.slick-slide[data-slick-index="0"] iframe').length <= 0
                                && slick.slideCount > 1
                            ){
                                timeout = setTimeout(function () {
                                    $bannerSlider.slick('slickNext');
                                }, $bannerSliderContainer.data('timeout'))
                            }
                        }, 1000);
                    });
                    
                    $bannerSlider.slick({
                        infinite: true,
                        arrows: false,
                        dots: true,
                        touchThreshold: 500,
                    });

                    $bannerSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        var $playToggle = $bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] .js-play-toggle');
                        if($playToggle.hasClass('playing')){
                            $playToggle.trigger('click')
                        }else if($bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] video').length){
                            playPauseMuteVideo($bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"]'),"pause");
                        }
                    });

                    $bannerSlider.on('afterChange', function(event, slick, currentSlide){
                        var $playToggle = $bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] .js-play-toggle');
                        if($playToggle.length){
                            if(!$playToggle.hasClass('playing')){
                                $playToggle.trigger('click')
                            }
                        }else if($bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] video').length){
                            playPauseMuteVideo($bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"]'),"play");
                        }
                        clearTimeout(timeout);
                        if($bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] video').length <= 0 
                            && $bannerSlider.find('.slick-slide[data-slick-index="'+currentSlide+'"] iframe').length <= 0
                            && slick.slideCount > 1
                        ){
                            timeout = setTimeout(function () {
                                $bannerSlider.slick('slickNext');
                            }, $bannerSliderContainer.data('timeout'))
                        }
                    });
                });

                function playPauseMuteVideo($currentSlide, control){
                    var slideType, startTime, player, video;
    
                    slideType = $currentSlide.find('[data-video-type]').data('video-type');
                    player = $currentSlide.find('iframe').get(0);
                    startTime = $currentSlide.data('video-start');
    
                    if (slideType === "youtube") {
                        switch (control) {
                            case "play":
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "mute"
                                });
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "playVideo"
                                });
                                break;
                            case "pause":
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "pauseVideo"
                                });
                                break;
                            case "mute":
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "mute"
                                });
                                break;
                            case "unmute":
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "unMute"
                                });
                                break;
                        }
                    } else if (slideType === "video") {
                        video = $currentSlide.find("video")[0];
                        if (video != null) {
                            if (control === "play"){
                                video.play();
                                if($currentSlide.parents('.slick-slider').slick('getSlick').slideCount > 1){
                                    video.removeEventListener('ended', handleVideoEnd);
                                    video.addEventListener('ended', handleVideoEnd);
                                }
                            } else if (control === "pause"){
                                video.pause();
                            } else if (control === "mute"){
                                video.muted = true;
                            } else if (control === "unmute"){
                                video.muted = false;
                            }
                        }
                    }
                }

                // POST commands to YouTube API
                function postMessageToPlayer(player, command){
                    if (player == null || command == null) return;
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }

                function handleVideoEnd(e){
                    $(e.currentTarget).parents('.slick-slider').slick('slickNext');
                }

                var lastWidth = 0;
                $(window).on('resize', function() {
                    $bannerSliderContainers.find('iframe').css('width', Math.max($bannerSliderContainers.outerWidth(), $bannerSliderContainers.outerHeight()*1920/1080)+'px');
                    $bannerSliderContainers.find('iframe').css('height', Math.max($bannerSliderContainers.outerHeight(), $bannerSliderContainers.outerWidth()*1080/1920)+'px');
                    if($bannerSliderContainers.data('state') == 'nsw'){
                        $bannerSliderContainers.find('video').css('width', Math.max($bannerSliderContainers.outerWidth(), $bannerSliderContainers.outerHeight()*1920/1080)+'px');
                        $bannerSliderContainers.find('video').css('height', Math.max($bannerSliderContainers.outerHeight(), $bannerSliderContainers.outerWidth()*1080/1920)+'px');
                    }else{
                        $bannerSliderContainers.find('video').css('width', Math.max($bannerSliderContainers.outerWidth(), $bannerSliderContainers.outerHeight()*2000/850)+'px');
                        $bannerSliderContainers.find('video').css('height', Math.max($bannerSliderContainers.outerHeight(), $bannerSliderContainers.outerWidth()*850/2000)+'px');
                    }
                    if($(window).outerWidth() < 992){
                        $bannerSliderContainers.find('video[data-mobile-src]').css('width', Math.max($bannerSliderContainers.outerWidth(), $bannerSliderContainers.outerHeight()*768/1000)+'px');
                        $bannerSliderContainers.find('video[data-mobile-src]').css('height', Math.max($bannerSliderContainers.outerHeight(), $bannerSliderContainers.outerWidth()*1000/768)+'px');
                        if(lastWidth == 0 || lastWidth >= 992){
                            lastWidth = $(window).outerWidth();
                            $bannerSliderContainers.find('video[data-mobile-src]').each(function(){
                                $(this).find('source').attr('src', $(this).data('mobile-src'));
                                $(this)[0].load();
                                if($(this).parents('.slick-active').length){
                                    $(this)[0].play();
                                }
                            });
                        }
                    }else{
                        if(lastWidth < 992){
                            lastWidth = $(window).outerWidth();
                            $bannerSliderContainers.find('video[data-src]').each(function(){
                                $(this).find('source').attr('src', $(this).data('src'));
                                $(this)[0].load();
                                if($(this).parents('.slick-active').length){
                                    $(this)[0].play();
                                }
                            });
                        }
                    }
                });
            }

            window.refreshListingSliders = function(){
                var $listingSliderContainers = $('.js-listing-slider-container');
                if ($listingSliderContainers.length > 0) {
                    $listingSliderContainers.each(function(){
                        var $listingSliderContainer = $(this);
                        var $listingSlider = $listingSliderContainer.find('.js-listing-slider');
                        var $facadeTitles = $listingSliderContainer.find('.js-listing-facade');
                        var $currentSlide = $listingSliderContainer.find('.js-listing-current');
                        
                        $listingSlider.slick({
                            infinite: true,
                            arrows: true,
                            dots: false,
                            touchThreshold: 500,
                            swipe: $listingSlider.data('enable-swipe') !== undefined,
                        });

                        $listingSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                            $facadeTitles.removeClass('active');
                            $facadeTitles.filter('[data-id="'+nextSlide+'"]').addClass('active');
                            $currentSlide.text(nextSlide + 1);
                        });

                        $listingSliderContainer.find('.js-slider-prev').on('click', function() {
                            $listingSlider.slick('slickPrev');
                        });

                        $listingSliderContainer.find('.js-slider-next').on('click', function() {
                            $listingSlider.slick('slickNext');
                        });
                    });
                }

                var $listingFloorplanSliderContainers = $('.js-listing-floorplan-slider-container');
                if ($listingFloorplanSliderContainers.length > 0) {
                    $listingFloorplanSliderContainers.each(function(){
                        var $listingFloorplanSliderContainer = $(this);
                        var $listingFloorplanSlider = $listingFloorplanSliderContainer.find('.js-listing-floorplan-slider');
                        var $floorplanLevels = $listingFloorplanSliderContainer.find('.js-listing-floorplan-level');
                        
                        $listingFloorplanSlider.slick({
                            infinite: true,
                            arrows: false,
                            dots: false,
                            swipe: true,
                            touchThreshold: 500,
                        });

                        $listingFloorplanSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                            $floorplanLevels.removeClass('active');
                            $floorplanLevels.filter('[data-id="'+nextSlide+'"]').addClass('active');
                        });

                        $floorplanLevels.on('click', function() {
                            $listingFloorplanSlider.slick('slickGoTo', $(this).data('id'));
                        });
                    });
                }
            }
            refreshListingSliders();

            var $facadesSliderContainer = $('.js-facades-slider-container');
            if ($facadesSliderContainer.length > 0) {
                var $facadesSlider = $facadesSliderContainer.find('.js-facades-slider');
                var $facadesSliderTracker = $facadesSliderContainer.find('.js-slider-tracker');
                var $facadesSliderCurrent = $facadesSliderContainer.find('.js-facades-slider-current');
                        
                $facadesSlider.on('init', function(event, slick){
                    $facadesSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $facadesSlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: false,
                    centerMode: true,
                    variableWidth: true,
                    touchThreshold: 500,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                centerMode: false,
                                arrows: false,
                            }
                        },
                    ]
                });

                $facadesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $facadesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    $facadesSliderCurrent.text(nextSlide + 1);
                });
            }
            
            window.refreshFacadesQldSliders = function(){
                var $facadesQldSliderContainers = $('.js-facades-qld-slider-container');
                if ($facadesQldSliderContainers.length > 0) {
                    $facadesQldSliderContainers.each(function(){
                        var $facadesQldSliderContainer = $(this);
                        var $facadesQldSlider = $facadesQldSliderContainer.find('.js-facades-qld-slider');
                        var $facadeTitles = $facadesQldSliderContainer.find('.js-facades-qld-facade');
                        var $currentSlide = $facadesQldSliderContainer.find('.js-facades-qld-current');
                        
                        $facadesQldSlider.slick({
                            infinite: true,
                            arrows: true,
                            dots: false,
                            centerMode: true,
                            variableWidth: true,
                            touchThreshold: 500,
                            responsive: [
                                {
                                    breakpoint: 991,
                                    settings: {
                                        centerMode: false,
                                        arrows: false,
                                        variableWidth: false,
                                    }
                                },
                            ]
                        });

                        $facadesQldSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                            $facadeTitles.removeClass('active');
                            $facadeTitles.filter('[data-id="'+nextSlide+'"]').addClass('active');
                            $currentSlide.text(nextSlide + 1);
                        });
        
                        $facadesQldSliderContainer.find('.js-slider-prev').on('click', function() {
                            $facadesQldSlider.slick('slickPrev');
                        });
        
                        $facadesQldSliderContainer.find('.js-slider-next').on('click', function() {
                            $facadesQldSlider.slick('slickNext');
                        });
                    });
                }
            }
            refreshFacadesQldSliders();

            var $gallerySliderContainer = $('.js-gallery-slider-container');
            if ($gallerySliderContainer.length > 0) {
                var $gallerySlider = $gallerySliderContainer.find('.js-gallery-slider');
                
                $gallerySlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: true,
                    centerMode: true,
                    variableWidth: true,
                    touchThreshold: 500,
                    centerPadding: '100px',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                variableWidth: false,
                                centerMode: false,
                                arrows: false,
                                centerPadding: '100px'
                            }
                        },
                    ]
                });
            }

            var $galleryThumbnailsSliderContainer = $('.js-gallery-thumbnails-slider-container');
            if ($galleryThumbnailsSliderContainer.length > 0) {
                var $gallerySlider = $galleryThumbnailsSliderContainer.find('.js-gallery-slider');
                var $thumbnailsSlider = $galleryThumbnailsSliderContainer.find('.js-thumbnails-slider');
                
                $gallerySlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: false,
                    touchThreshold: 500,
                    asNavFor: '.js-thumbnails-slider',
                });

                $thumbnailsSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    touchThreshold: 500,
                    asNavFor: '.js-gallery-slider',
                });

                window.goToGallerySlide = function(index){
                    $gallerySlider.slick('slickGoTo', index);
                }
            }

            var $virtualSliderContainer = $('.js-virtual-slider-container');
            if ($virtualSliderContainer.length > 0) {
                var $virtualSlider = $virtualSliderContainer.find('.js-virtual-slider');
                
                $virtualSlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: true,
                    centerMode: true,
                    variableWidth: true,
                    touchThreshold: 500,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                variableWidth: false,
                                centerMode: false,
                                arrows: false,
                            }
                        },
                    ]
                });
            }

            var $videosSliderContainer = $('.js-videos-slider-container');
            if ($videosSliderContainer.length > 0) {
                if(typeof YT === 'undefined' && typeof window.startedLoadingYT === 'undefined'){
                    window.startedLoadingYT = true;
                    $.getScript( "https://www.youtube.com/iframe_api", function( data, textStatus, jqxhr ) {
                        console.log( "Loaded Youtube API" );
                    });
                }

                var $videosSlider = $videosSliderContainer.find('.js-videos-slider');
                
                $videosSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: true,
                    touchThreshold: 500,
                });

                $videosSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $videosSlider.find('iframe').replaceWith('<div class="autoplay-video-holder"></div>');
                });
            }

            window.refreshHomeSliders = function(){
                var $homesSliderContainer = $('.js-homes-slider-container');
                if ($homesSliderContainer.length > 0) {
                    var $homesSlider = $homesSliderContainer.find('.js-homes-slider');
                    var $homesSliderTracker = $homesSliderContainer.find('.js-slider-tracker');
                        
                    $homesSlider.on('init', function(event, slick){
                        $homesSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    $homesSlider.not('.slick-initialized').slick({
                        infinite: false,
                        arrows: true,
                        dots: false,
                        variableWidth: true,
                        centerMode: false,
                        touchThreshold: 500,
                    });

                    $homesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $homesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                }
            }
            refreshHomeSliders();

            var $featuredHomesSliderContainer = $('.js-featured-homes-slider-container');
            if ($featuredHomesSliderContainer.length > 0) {
                var $featuredHomesSlider = $featuredHomesSliderContainer.find('.js-featured-homes-slider');
                var $featuredHomesSliderTracker = $featuredHomesSliderContainer.find('.js-slider-tracker');
                    
                $featuredHomesSlider.on('init', function(event, slick){
                    $featuredHomesSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $featuredHomesSlider.slick({
                    infinite: false,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    centerMode: false,
                    mobileFirst: true,
                    touchThreshold: 500,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                variableWidth: false,
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            }
                        },
                    ]
                });

                $featuredHomesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $featuredHomesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                });
            }

            var $featuredLocationsSliderContainer = $('.js-featured-locations-slider-container');
            if ($featuredLocationsSliderContainer.length > 0) {
                var $featuredLocationsSlider = $featuredLocationsSliderContainer.find('.js-featured-locations-slider');
                var $sliderTracker = $featuredLocationsSliderContainer.find('.js-slider-tracker');

                $featuredLocationsSlider.on('init', function(event, slick){
                    $sliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $featuredLocationsSlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: false,
                    variableWidth: true,
                    touchThreshold: 500,
                });

                $featuredLocationsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $sliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                }); 
            }

            var $promotionsSliderContainer = $('.js-promotions-slider-container');
            if ($promotionsSliderContainer.length > 0) {
                var $promotionsSlider = $promotionsSliderContainer.find('.js-promotions-slider');
                
                $promotionsSlider.slick({
                    infinite: true,
                    arrows: true,
                    dots: true,
                    touchThreshold: 500,
                });
            }

            var $columnSliderContainers = $('.js-column-slider-container');
            if ($columnSliderContainers.length > 0) {
                $columnSliderContainers.each(function(){
                    var $columnSliderContainer = $(this);
                    var $columnSlider = $columnSliderContainer.find('.js-column-slider');

                    var $columnSliderTracker = $columnSliderContainer.find('.js-slider-tracker');
                        
                    $columnSlider.on('init', function(event, slick){
                        $columnSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    const columnSliderSettings = {
                        infinite: false,
                        arrows: false,
                        dots: false,
                        touchThreshold: 500,
                        variableWidth: true,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: 'unslick',
                            },
                        ]
                    };

                    $columnSlider.slick(columnSliderSettings);

                    $(window).on('resize', function() {
                        if($(window).width() < 992 && !$columnSlider.hasClass('slick-initialized')){
                            $columnSlider.slick(columnSliderSettings);
                        }
                    });

                    $columnSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $columnSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });   
                });
            }

            var $relatedArticlesSliderContainer = $('.js-related-articles-slider-container');
            if ($relatedArticlesSliderContainer.length > 0) {
                var $relatedArticlesSlider = $relatedArticlesSliderContainer.find('.js-related-articles-slider');

                var $relatedArticlesSliderTracker = $relatedArticlesSliderContainer.find('.js-slider-tracker');
                    
                $relatedArticlesSlider.on('init', function(event, slick){
                    $relatedArticlesSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $relatedArticlesSlider.slick({
                    infinite: false,
                    arrows: false,
                    dots: false,
                    touchThreshold: 500,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    centerMode: false,
                    responsive: [
                        {
                            breakpoint: 1365,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        },
                    ]
                });

                $relatedArticlesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $relatedArticlesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                });
            }

            var $filteredHomesSliderContainers = $('.js-filtered-homes-slider-container');
            if ($filteredHomesSliderContainers.length > 0) {
                $filteredHomesSliderContainers.each(function(){
                    var $filteredHomesSliderContainer = $(this);
                    var $filteredHomesSlider = $filteredHomesSliderContainer.find('.js-filtered-homes-slider');

                    var $filteredHomesSliderTracker = $filteredHomesSliderContainer.find('.js-slider-tracker');
                        
                    $filteredHomesSlider.on('init', function(event, slick){
                        if($(window).width() > 1365){
                            $filteredHomesSliderTracker.css('width', (100/(slick.slideCount - 2))+'%');
                        }else if($(window).width() > 991){
                            $filteredHomesSliderTracker.css('width', (100/(slick.slideCount - 1))+'%');
                        }else{
                            $filteredHomesSliderTracker.css('width', (100/slick.slideCount)+'%');
                        }
                    });
                    
                    $filteredHomesSlider.slick({
                        infinite: false,
                        arrows: false,
                        dots: false,
                        touchThreshold: 500,
                        variableWidth: true,
                        slidesToShow: 3,
                        responsive: [
                            {
                                breakpoint: 1365,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                }
                            },
                        ]
                    });

                    $filteredHomesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $filteredHomesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                });
            }

            var $finiteSliderContainers = $('.js-finite-slider-container');
            if ($finiteSliderContainers.length > 0) {
                $finiteSliderContainers.each(function(){
                    var $finiteSliderContainer = $(this);
                    var $finiteSlider = $finiteSliderContainer.find('.js-finite-slider');

                    var $finiteSliderTracker = $finiteSliderContainer.find('.js-slider-tracker');
                        
                    $finiteSlider.on('init', function(event, slick){
                        $finiteSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    $finiteSlider.slick({
                        infinite: false,
                        arrows: false,
                        dots: false,
                        touchThreshold: 500,
                        variableWidth: true,
                    });

                    $finiteSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $finiteSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                });
            }

            var $stepsSliderContainers = $('.js-steps-slider-container');
            if ($stepsSliderContainers.length > 0) {
                $stepsSliderContainers.each(function(){
                    var $stepsSliderContainer = $(this);
                    var $stepsSlider = $stepsSliderContainer.find('.js-steps-slider');

                    var $stepsSliderTracker = $stepsSliderContainer.find('.js-slider-tracker');

                    $stepsSlider.on('init', function(event, slick){
                        if($(window).width() > 1365){
                            $stepsSliderTracker.css('width', (100/(slick.slideCount - 2))+'%');
                        }else if($(window).width() > 991){
                            $stepsSliderTracker.css('width', (100/(slick.slideCount - 1))+'%');
                        }else{
                            $stepsSliderTracker.css('width', (100/slick.slideCount)+'%');
                        }
                    });
                    
                    $stepsSlider.slick({
                        infinite: false,
                        arrows: true,
                        dots: false,
                        touchThreshold: 500,
                        variableWidth: true,
                        slidesToShow: 3,
                        responsive: [
                            {
                                breakpoint: 1365,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                }
                            },
                        ]
                    });

                    var $prevButton = $stepsSliderContainer.closest('.js-tabs-page').find('.js-slider-prev')
                    var $nextButton = $stepsSliderContainer.closest('.js-tabs-page').find('.js-slider-next')

                    $stepsSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        $prevButton.removeClass('disabled')
                        $nextButton.removeClass('disabled')
                        if (currentSlide == 0) {
                            $prevButton.addClass('disabled')
                        }
                        if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
                            $nextButton.addClass('disabled')
                        }
                    })

                    $prevButton.on('click', function () {
                        if ($(this).hasClass('disabled')) return
                        $stepsSlider.slick('slickPrev');
                    })
                    $nextButton.on('click', function () {
                        if ($(this).hasClass('disabled')) return
                        $stepsSlider.slick('slickNext');
                    })

                    $stepsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $stepsSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });

                    $(window).on('resize', function(){
                        $stepsSlider[0].slick.refresh();
                    });
                });
            }

            var $jobsSliderContainer = $('.js-jobs-slider-container');
            if ($jobsSliderContainer.length > 0) {
                var $jobsSlider = $jobsSliderContainer.find('.js-jobs-slider');
                var $jobsSliderTracker = $jobsSliderContainer.find('.js-slider-tracker');
                    
                $jobsSlider.on('init', function(event, slick){
                    $jobsSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                const jobsSliderSettings = {
                    infinite: false,
                    arrows: false,
                    dots: false,
                    touchThreshold: 500,
                    variableWidth: true,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: 'unslick',
                        },
                    ]
                };

                $jobsSlider.slick(jobsSliderSettings);

                $(window).on('resize', function() {
                    if($(window).width() < 768 && !$jobsSlider.hasClass('slick-initialized')){
                        $jobsSlider.find('.job').show();
                        $jobsSlider.slick(jobsSliderSettings);
                    }
                });

                $jobsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $jobsSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                });
                
                $jobsSliderContainer.find('.js-jobs-select').on('change', function(){
                    var company = $jobsSliderContainer.find('.js-jobs-select[name="company"]').val();
                    var suburb = $jobsSliderContainer.find('.js-jobs-select[name="suburb"]').val();
                    var state = $jobsSliderContainer.find('.js-jobs-select[name="state"]').val();
                    if(company !='' || state != '' || suburb != ''){
                        var filters = '';
                        if(state != ''){
                            filters += '[data-state="'+state+'"]';
                        }
                        if(suburb != ''){
                            filters += '[data-suburb="'+suburb+'"]';
                        }
                        if(company != ''){
                            filters += '[data-company="'+company+'"]';
                        }
                        if($jobsSlider.hasClass('slick-initialized')){
                            $jobsSlider.slick('slickUnfilter');
                            $jobsSlider.slick('slickFilter', $(filters).parent().parent());
                        }else{
                            $jobsSlider.find('.job').hide();
                            $jobsSlider.find('.job'+filters).show();
                        }
                    }else{
                        if($jobsSlider.hasClass('slick-initialized')){
                            $jobsSlider.slick('slickUnfilter');
                        }else{
                            $jobsSlider.find('.job').show();
                        }
                    }
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Sliders;